import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { globalVariablesServer} from '../globals';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})


export class LoginService {

  
  private headers: HttpHeaders;
  constructor(private http: HttpClient) {this.headers = new HttpHeaders({ 
    'Content-Type': 'application/json; charset=utf-8',
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token, Accept, Authorization, X-Request-With",
    "Access-Control-Allow-Credentials" : "true",
    "Access-Control-Allow-Methods" : "GET, POST, DELETE, PUT, OPTIONS, TRACE, PATCH, CONNECT"  
  
  }); }


  AppUserLog(paramdata) { 
    console.log('11');
 
    return this.http.post(globalVariablesServer.apiurl + 'api/ApiAppUsers/AppUserLog',JSON.stringify(paramdata), { headers: this.headers })
    .pipe(
      catchError(this.handleError('Error in Service', []))
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      console.log(`${operation} failed: ${error.message}`);
      return of(result as T);
    };
  }

  Login(paramdata) {  
    return this.http.post(globalVariablesServer.apiurl + 'api/ApiAppUsers/Login',paramdata, { headers: this.headers });
  }

 

}
